import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 14" {...props}>
      <g>
        <circle cx="7.5" cy="7" r="7" fill="#000"></circle>
        <circle cx="7.5" cy="7" r="4" fill="#fff"></circle>
      </g>
    </svg>
  )
}
